import { useDispatch, useSelector } from "react-redux";
import { updateLoginForm } from "../redux/userSlice";
import { login } from "../api/userAPI";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import NavbarMobile from "./NavbarMobile";
import NavbarDesktop from "./NavbarDesktop";
import Loader from "./Loader";

function Login() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginForm = useSelector(state => state.user.loginForm)
    const loading = useSelector(state => state.user.loading)

    const validate = () => {
        let valid = true;

        if (loginForm.username === "") {
            valid = false;
            dispatch(updateLoginForm({field: "error", value: "Must enter a username"}))
        } else if (loginForm.password === "") {
            valid = false;
            dispatch(updateLoginForm({field: "error", value: "Must enter a password"}))
        }

        return valid
    }

    const handleLogin = (event) => {
        event.preventDefault();
        if (validate()) {
            dispatch(login({username: loginForm.username, password: loginForm.password, navigate}));
        }
    }

    return(
        <div className="text-center top-margin">
            <NavbarDesktop />
            <NavbarMobile />
            {loading && <div className="modal">
                <div className="modal-content">
                    <Loader />
                </div>
            </div>}

            <h1 className="">Login</h1>
            <form className="login shadow-lg mobile-w-10-12">
                <h2 className="mb-7">Sign into Your Account</h2>

                <div>
                    <label htmlFor='username' className=''>username</label>
                    <input 
                        type="text" 
                        name="username" 
                        id="username" 
                        className='w-11/12' 
                        onChange={(event) => dispatch(updateLoginForm({field: event.target.name, value: event.target.value}))} 
                        placeholder="Enter Username" 
                    />
                </div>

                <div>
                    <label htmlFor='password' className=''>password</label>
                    <input 
                        type="password"
                        name="password" 
                        id="password" 
                        className='w-11/12' 
                        placeholder='Enter Password' 
                        onChange={(event) => dispatch(updateLoginForm({field: event.target.name, value: event.target.value}))}
                    />
                </div>

                <button className="block mx-auto my-3 btn-primary" onClick={(event) => handleLogin(event)}>Sign In</button>

                <p className="my-3">{loginForm.error}</p>

                <Link to="/register">New? <span className="link-embedded">Create an account</span></Link>
                <Link to="/reset"><p className="link-embedded">Forgot Password?</p></Link>
            </form>
        </div>
    )
}

export default Login;